import { render, staticRenderFns } from "./TotalElementos.vue?vue&type=template&id=1007d570&"
import script from "./TotalElementos.vue?vue&type=script&lang=js&"
export * from "./TotalElementos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports